/**
 * Environment Configuration Utility
 *
 * Facade that selects server vs client resolution:
 *   - SSR (import.meta.env.SSR): process.env / ECS task def first
 *     → prefers STOREFRONT_BFF_INTERNAL_URL for BFF
 *   - Browser: window.__ENV__ first (deploy env-config.js)
 *
 * Note: implementations live in env.node.ts / env.browser.ts (not *.server.ts /
 * *.client.ts) so Vike file-env guards don't reject this shared facade.
 * See env.node.ts header for the ECS env contract documented for platform.
 */

import type { EnvConfig } from './env.types';
import {
  env as serverEnv,
  isDev as serverIsDev,
  getApiUrl as serverGetApiUrl,
} from './env.node';
import {
  env as clientEnv,
  isDev as clientIsDev,
  getApiUrl as clientGetApiUrl,
} from './env.browser';

export type { EnvConfig };
export const env: EnvConfig = import.meta.env.SSR ? serverEnv : clientEnv;
export const isDev = import.meta.env.SSR ? serverIsDev : clientIsDev;
export const getApiUrl = import.meta.env.SSR ? serverGetApiUrl : clientGetApiUrl;
